export const WHY_GOUSTO = {
  altText:
    'Collection of Gousto recipes with salmon tacos, fresh veg gnocchi and a lentil mango dal.',
  ctaText: 'Treat your tastebuds with 50% off',
}
